import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import { getTextStyle } from '../../../../../../generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../../../../generic/global/bou-colors';
import { FadeIn } from '../../../../../../generic/layout/fade-in';
import { useImpactChartContext } from '../context';

export const ContributingArticlesCount = () => {
  const { contributingArticlesCount, hasFinishedLoading } = useImpactChartContext();

  if (!hasFinishedLoading) {
    return <Skeleton width={'10em'} />;
  }

  if ((contributingArticlesCount || 0) < 10000) {
    return <></>;
  }

  return (
    <Root>
      <FadeIn>
        Based on <Value>{formatContributingArticlesCount(contributingArticlesCount)}</Value> scientific articles.
      </FadeIn>
    </Root>
  );
};

export const Root = styled.div`
  ${getTextStyle({ size: 'xxxs' })}
  color: ${BouColor.TOOL_TEXT_DARK_GRAY};
`;
export const Value = styled.span`
  font-weight: bold;
`;

function formatContributingArticlesCount(count: number | undefined) {
  if (count === undefined) {
    return '0';
  }
  if (count >= 4000000) {
    return `${(count / 1000000).toFixed(0)}M+`;
  }
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1)}M+`;
  }
  if (count >= 5000) {
    return `${(count / 1000).toFixed(0)}k+`;
  }
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k+`;
  }
  return `${count.toFixed(0)}`;
}
